import { gray, green, red, yellow, azure, orange, purple, blackAlpha, magenta, cyan, rose, blue } from '../colors-experimental.mjs';
import { size } from '../size.mjs';
import { createMetaTheme, createMetaThemePartial } from './utils.mjs';

var metaThemeLightUpliftPartial = createMetaThemePartial({
  border: {
    // v12.0.0
    'border-radius-0': {
      value: size[0]
    },
    'border-radius-050': {
      value: size['050']
    },
    'border-radius-100': {
      value: size[100]
    },
    'border-radius-150': {
      value: size[150]
    },
    'border-radius-200': {
      value: size[200]
    },
    'border-radius-300': {
      value: size[300]
    },
    'border-radius-400': {
      value: size[400]
    },
    'border-radius-500': {
      value: size[500]
    },
    'border-radius-750': {
      value: size[750]
    },
    'border-width-0165': {
      value: size['0165']
    },
    'border-width-025': {
      value: size['025']
    },
    'border-width-050': {
      value: size['050']
    },
    'border-width-100': {
      value: size[100]
    }
  },
  color: {
    // v12.0.0
    'color-bg-surface': {
      value: gray[1]
    },
    'color-bg-surface-secondary': {
      value: gray[4]
    },
    'color-bg-surface-secondary-hover': {
      value: gray[6]
    },
    'color-bg-surface-secondary-active': {
      value: gray[7]
    },
    'color-bg-surface-tertiary': {
      value: gray[5]
    },
    'color-bg-fill-tertiary': {
      value: gray[8]
    },
    'color-bg-fill-tertiary-hover': {
      value: gray[9]
    },
    'color-bg-fill-tertiary-active': {
      value: gray[10]
    },
    'color-input-bg-surface': {
      value: gray[2]
    },
    'color-input-bg-surface-hover': {
      value: gray[3]
    },
    'color-input-bg-surface-active': {
      value: gray[4]
    },
    'color-bg-surface-selected': {
      value: gray[3]
    },
    'color-bg-fill-success': {
      value: green[12]
    },
    'color-bg-fill-success-hover': {
      value: green[13]
    },
    'color-bg-fill-success-active': {
      value: green[14]
    },
    'color-bg-fill-success-secondary': {
      value: green[3]
    },
    'color-bg-surface-success': {
      value: green[3]
    },
    'color-bg-surface-success-hover': {
      value: green[4]
    },
    'color-bg-surface-success-active': {
      value: green[5]
    },
    'color-bg-fill-critical': {
      value: red[12]
    },
    'color-bg-fill-critical-hover': {
      value: red[13]
    },
    'color-bg-fill-critical-active': {
      value: red[14]
    },
    'color-bg-fill-critical-secondary': {
      value: red[6]
    },
    'color-bg-surface-critical': {
      value: red[4]
    },
    'color-bg-surface-critical-hover': {
      value: red[5]
    },
    'color-bg-surface-critical-active': {
      value: red[6]
    },
    'color-bg-fill-caution': {
      value: yellow[6]
    },
    'color-bg-fill-caution-secondary': {
      value: yellow[4]
    },
    'color-bg-surface-caution': {
      value: yellow[2]
    },
    'color-bg-surface-caution-hover': {
      value: yellow[3]
    },
    'color-bg-surface-caution-active': {
      value: yellow[4]
    },
    'color-bg-fill-info': {
      value: azure[9]
    },
    'color-bg-fill-info-secondary': {
      value: azure[4]
    },
    'color-bg-surface-info': {
      value: azure[3]
    },
    'color-bg-surface-info-hover': {
      value: azure[4]
    },
    'color-bg-surface-info-active': {
      value: azure[6]
    },
    'color-bg-fill-warning': {
      value: orange[9]
    },
    'color-bg-fill-warning-secondary': {
      value: orange[7]
    },
    'color-bg-surface-warning': {
      value: orange[3]
    },
    'color-bg-fill-magic': {
      value: purple[12]
    },
    'color-bg-fill-magic-secondary': {
      value: purple[6]
    },
    'color-bg-fill-magic-secondary-hover': {
      value: purple[7]
    },
    'color-bg-fill-magic-secondary-active': {
      value: purple[8]
    },
    'color-bg-surface-magic-hover': {
      value: purple[4]
    },
    'color-bg-fill-secondary': {
      value: gray[6]
    },
    'color-bg-fill-inverse': {
      value: gray[15]
    },
    'color-bg-fill-inverse-hover': {
      value: gray[14]
    },
    'color-bg-fill-inverse-active': {
      value: gray[13]
    },
    'color-bg-surface-transparent': {
      value: blackAlpha[1]
    },
    'color-bg-fill-transparent-hover': {
      value: blackAlpha[5]
    },
    'color-bg-fill-transparent-active': {
      value: blackAlpha[6]
    },
    'color-bg-fill-disabled': {
      value: blackAlpha[5]
    },
    'color-bg-fill-transparent-secondary': {
      value: blackAlpha[6]
    },
    'color-bg-fill-brand-disabled': {
      value: blackAlpha[9]
    },
    'color-backdrop-bg': {
      value: blackAlpha[14]
    },
    'color-avatar-bg-fill': {
      value: gray[11]
    },
    'color-avatar-one-bg-fill': {
      value: magenta[7]
    },
    'color-avatar-two-bg-fill': {
      value: green[7]
    },
    'color-avatar-three-bg-fill': {
      value: cyan[7]
    },
    'color-avatar-four-bg-fill': {
      value: azure[7]
    },
    'color-avatar-five-bg-fill': {
      value: rose[7]
    },
    'color-text-secondary': {
      value: gray[13]
    },
    'color-text-emphasis': {
      value: blue[13]
    },
    'color-text-emphasis-hover': {
      value: blue[14]
    },
    'color-text-emphasis-active': {
      value: blue[15]
    },
    'color-text-brand': {
      value: gray[14]
    },
    'color-text-brand-hover': {
      value: gray[15]
    },
    'color-text-info-on-bg-fill': {
      value: azure[16]
    },
    'color-text-inverse-secondary': {
      value: gray[11]
    },
    'color-avatar-text-on-bg-fill': {
      value: gray[1]
    },
    'color-avatar-one-text-on-bg-fill': {
      value: magenta[14]
    },
    'color-avatar-two-text-on-bg-fill': {
      value: green[14]
    },
    'color-avatar-three-text-on-bg-fill': {
      value: cyan[14]
    },
    'color-avatar-four-text-on-bg-fill': {
      value: azure[14]
    },
    'color-avatar-five-text-on-bg-fill': {
      value: rose[14]
    },
    'color-icon-secondary': {
      value: gray[12]
    },
    'color-icon-emphasis': {
      value: blue[13]
    },
    'color-icon-emphasis-hover': {
      value: blue[14]
    },
    'color-icon-emphasis-active': {
      value: blue[15]
    },
    'color-icon-brand': {
      value: gray[16]
    },
    'color-border-secondary': {
      value: gray[7]
    },
    'color-input-border': {
      value: gray[12]
    },
    'color-input-border-hover': {
      value: gray[13]
    },
    'color-input-border-active': {
      value: gray[16]
    },
    'color-border-emphasis-hover': {
      value: blue[14]
    },
    'color-border-emphasis-active': {
      value: blue[15]
    },
    'color-border-focus': {
      value: blue[13]
    },
    'color-border-brand': {
      value: gray[8]
    },
    'color-border-critical-secondary': {
      value: red[14]
    },
    'color-border-magic-secondary': {
      value: purple[12]
    },
    // v11.0.0
    'color-bg-inverse': {
      value: gray[16]
    },
    'color-bg-inset-strong': {
      value: gray[15]
    },
    'color-bg-inverse-hover': {
      value: gray[14]
    },
    'color-bg-inverse-active': {
      value: gray[13]
    },
    'color-bg-strong-hover': {
      value: gray[9]
    },
    'color-bg-strong-active': {
      value: gray[10]
    },
    'color-bg-strong': {
      value: gray[8]
    },
    'color-bg-subdued-active': {
      value: gray[7]
    },
    'color-bg-disabled': {
      value: gray[7]
    },
    'color-bg-interactive-disabled': {
      value: gray[7]
    },
    'color-bg-app': {
      value: gray[6]
    },
    'color-bg-app-hover': {
      value: gray[2]
    },
    'color-bg-app-selected': {
      value: gray[3]
    },
    'color-bg-active': {
      value: gray[4]
    },
    'color-bg-subdued-hover': {
      value: gray[6]
    },
    'color-bg-inset': {
      value: gray[6]
    },
    'color-bg-hover': {
      value: gray[3]
    },
    'color-bg-subdued': {
      value: gray[4]
    },
    'color-bg-input': {
      value: gray[1]
    },
    'color-bg': {
      value: gray[1]
    },
    'color-bg-primary-active': {
      value: gray[16]
    },
    'color-bg-primary-hover': {
      value: gray[16]
    },
    'color-bg-primary': {
      value: gray[15]
    },
    'color-bg-success-strong': {
      value: green[12]
    },
    'color-bg-success': {
      value: green[3]
    },
    'color-bg-primary-subdued-active': {
      value: gray[6]
    },
    'color-bg-success-subdued': {
      value: green[3]
    },
    'color-bg-primary-subdued-hover': {
      value: gray[7]
    },
    'color-bg-success-subdued-hover': {
      value: green[5]
    },
    'color-bg-primary-subdued': {
      value: gray[8]
    },
    'color-bg-primary-subdued-selected': {
      value: gray[6]
    },
    'color-bg-critical-strong-active': {
      value: red[14]
    },
    'color-bg-critical-strong-hover': {
      value: red[13]
    },
    'color-bg-critical-strong': {
      value: red[12]
    },
    'color-bg-critical-subdued-active': {
      value: red[6]
    },
    'color-bg-critical': {
      value: red[6]
    },
    'color-bg-critical-subdued': {
      value: red[4]
    },
    'color-bg-critical-subdued-hover': {
      value: red[5]
    },
    'color-bg-caution-strong': {
      value: yellow[6]
    },
    'color-bg-caution': {
      value: yellow[4]
    },
    'color-bg-caution-subdued-active': {
      value: yellow[4]
    },
    'color-bg-caution-subdued': {
      value: yellow[2]
    },
    'color-bg-caution-subdued-hover': {
      value: yellow[3]
    },
    'color-bg-info-strong': {
      value: azure[9]
    },
    'color-bg-info-subdued-active': {
      value: azure[6]
    },
    'color-bg-info': {
      value: azure[4]
    },
    'color-bg-info-subdued': {
      value: azure[3]
    },
    'color-bg-info-subdued-hover': {
      value: azure[4]
    },
    'color-bg-interactive-active': {
      value: gray[14]
    },
    'color-bg-interactive-hover': {
      value: gray[15]
    },
    'color-bg-interactive': {
      value: gray[16]
    },
    'color-bg-interactive-subdued-active': {
      value: gray[6]
    },
    'color-bg-interactive-subdued-hover': {
      value: gray[7]
    },
    'color-bg-interactive-subdued': {
      value: gray[8]
    },
    'color-bg-interactive-selected': {
      value: gray[6]
    },
    'color-bg-warning': {
      value: orange[7]
    },
    'color-bg-magic-strong': {
      value: purple[12]
    },
    'color-bg-magic-hover': {
      value: purple[7]
    },
    'color-bg-magic-active': {
      value: purple[8]
    },
    'color-bg-magic': {
      value: purple[6]
    },
    'color-bg-magic-subdued-hover': {
      value: purple[4]
    },
    'color-bg-magic-subdued-active': {
      value: purple[6]
    },
    'color-bg-magic-subdued': {
      value: purple[3]
    },
    'color-border-input-hover': {
      value: gray[13]
    },
    'color-border-inverse': {
      value: gray[13]
    },
    'color-border-strong-hover': {
      value: gray[11]
    },
    'color-border-input': {
      value: gray[12]
    },
    'color-border-hover': {
      value: gray[10]
    },
    'color-border-strong': {
      value: gray[10]
    },
    'color-border': {
      value: gray[8]
    },
    'color-border-disabled': {
      value: gray[7]
    },
    'color-border-subdued': {
      value: gray[7]
    },
    'color-border-interactive-disabled': {
      value: gray[7]
    },
    'color-border-primary': {
      value: gray[8]
    },
    'color-border-success': {
      value: green[5]
    },
    'color-border-success-subdued': {
      value: green[5]
    },
    'color-border-critical-active': {
      value: red[11]
    },
    'color-border-critical-hover': {
      value: red[10]
    },
    'color-border-critical': {
      value: red[9]
    },
    'color-border-critical-subdued': {
      value: red[9]
    },
    'color-border-caution': {
      value: yellow[5]
    },
    'color-border-caution-subdued': {
      value: yellow[5]
    },
    'color-border-info': {
      value: azure[9]
    },
    'color-border-info-subdued': {
      value: azure[9]
    },
    'color-border-interactive-active': {
      value: blue[15]
    },
    'color-border-interactive-hover': {
      value: blue[14]
    },
    'color-border-interactive': {
      value: blue[13]
    },
    'color-border-interactive-focus': {
      value: blue[13]
    },
    'color-border-interactive-subdued': {
      value: blue[13]
    },
    'color-border-magic-strong': {
      value: purple[12]
    },
    'color-border-magic': {
      value: purple[10]
    },
    'color-icon-hover': {
      value: gray[15]
    },
    'color-icon': {
      value: gray[14]
    },
    'color-icon-subdued': {
      value: gray[12]
    },
    'color-icon-disabled': {
      value: gray[10]
    },
    'color-icon-interactive-disabled': {
      value: gray[10]
    },
    'color-icon-inverse': {
      value: gray[8]
    },
    'color-icon-on-color': {
      value: gray[1]
    },
    'color-icon-primary': {
      value: gray[16]
    },
    'color-icon-success': {
      value: green[12]
    },
    'color-icon-critical': {
      value: red[11]
    },
    'color-icon-caution': {
      value: yellow[11]
    },
    'color-icon-info': {
      value: azure[11]
    },
    'color-icon-warning': {
      value: orange[11]
    },
    'color-icon-interactive-active': {
      value: blue[15]
    },
    'color-icon-interactive-hover': {
      value: blue[14]
    },
    'color-icon-interactive': {
      value: blue[13]
    },
    'color-icon-interactive-inverse': {
      value: blue[8]
    },
    'color-icon-magic': {
      value: purple[13]
    },
    'color-text': {
      value: gray[15]
    },
    'color-text-subdued': {
      value: gray[13]
    },
    'color-text-disabled': {
      value: gray[11]
    },
    'color-text-interactive-disabled': {
      value: gray[10]
    },
    'color-text-inverse-subdued': {
      value: gray[10]
    },
    'color-text-inverse': {
      value: gray[8]
    },
    'color-text-on-color': {
      value: gray[1]
    },
    'color-text-success-strong': {
      value: green[15]
    },
    'color-text-success': {
      value: green[15]
    },
    'color-text-primary': {
      value: gray[14]
    },
    'color-text-primary-hover': {
      value: gray[14]
    },
    'color-text-critical-strong': {
      value: red[14]
    },
    'color-text-critical-active': {
      value: red[16]
    },
    'color-text-critical': {
      value: red[14]
    },
    'color-text-caution-strong': {
      value: yellow[15]
    },
    'color-text-caution': {
      value: yellow[15]
    },
    'color-text-info-strong': {
      value: azure[16]
    },
    'color-text-info': {
      value: azure[14]
    },
    'color-text-warning-strong': {
      value: orange[16]
    },
    'color-text-interactive-active': {
      value: blue[15]
    },
    'color-text-interactive-hover': {
      value: blue[14]
    },
    'color-text-interactive': {
      value: blue[13]
    },
    'color-text-interactive-inverse': {
      value: blue[8]
    },
    'color-text-magic-strong': {
      value: purple[15]
    },
    'color-text-magic': {
      value: purple[14]
    }
  },
  font: {
    // v12.0.0
    'font-size-275': {
      value: size[275]
    },
    'font-size-325': {
      value: size[325]
    },
    'font-size-350': {
      value: size[350]
    },
    'font-size-750': {
      value: size[750]
    },
    'font-size-900': {
      value: size[900]
    },
    'font-size-1000': {
      value: size[1000]
    },
    'font-line-height-300': {
      value: size[300]
    },
    'font-line-height-400': {
      value: size[400]
    },
    'font-line-height-500': {
      value: size[500]
    },
    'font-line-height-600': {
      value: size[600]
    },
    'font-line-height-700': {
      value: size[700]
    },
    'font-line-height-800': {
      value: size[800]
    },
    'font-line-height-1000': {
      value: size[1000]
    },
    'font-line-height-1200': {
      value: size[1200]
    },
    // v11.0.0
    'font-family-sans': {
      value: "'Inter', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif"
    },
    'font-size-500': {
      value: '30px'
    },
    'font-size-600': {
      value: '36px'
    }
  },
  motion: {
    // v11.0.0
    'motion-ease-out': {
      value: 'cubic-bezier(0.19, 0.91, 0.38, 1)'
    }
  },
  space: {
    // v12.0.0
    'space-050': {
      value: size['050']
    },
    'space-100': {
      value: size[100]
    },
    'space-150': {
      value: size[150]
    },
    'space-200': {
      value: size[200]
    },
    'space-300': {
      value: size[300]
    },
    'space-400': {
      value: size[400]
    },
    'space-500': {
      value: size[500]
    },
    'space-600': {
      value: size[600]
    },
    'space-800': {
      value: size[800]
    },
    'space-1000': {
      value: size[1000]
    },
    'space-1200': {
      value: size[1200]
    },
    'space-1600': {
      value: size[1600]
    },
    'space-2000': {
      value: size[2000]
    },
    'space-2400': {
      value: size[2400]
    },
    'space-2800': {
      value: size[2800]
    },
    'space-3200': {
      value: size[3200]
    }
  },
  shadow: {
    // v11.0.0
    'shadow-inset-lg': {
      value: 'inset -1px 0px 1px rgba(0, 0, 0, 0.2), inset 1px 0px 1px rgba(0, 0, 0, 0.2), inset 0px 2px 1px rgba(0, 0, 0, 0.6)'
    },
    'shadow-inset-md': {
      value: 'inset -1px 0px 1px rgba(0, 0, 0, 0.12), inset 1px 0px 1px rgba(0, 0, 0, 0.12), inset 0px 2px 1px rgba(0, 0, 0, 0.2)'
    },
    'shadow-inset-sm': {
      value: 'inset 0px 1px 1px rgba(0, 0, 0, 0.15), inset 0px 1px 2px rgba(255, 255, 255, 0.15)'
    },
    'shadow-xs': {
      value: '0px 1px 0px rgba(0, 0, 0, 0.07)'
    },
    'shadow-sm': {
      value: '0px 3px 1px -1px rgba(0, 0, 0, 0.07)'
    },
    'shadow-md': {
      value: '0px 4px 6px -2px rgba(0, 0, 0, 0.2)'
    },
    'shadow-lg': {
      value: '0px 8px 16px -4px rgba(0, 0, 0, 0.22)'
    },
    'shadow-xl': {
      value: '0px 12px 20px -8px rgba(0, 0, 0, 0.24)'
    },
    'shadow-2xl': {
      value: '0px 20px 20px -8px rgba(0, 0, 0, 0.28)'
    }
  }
});
createMetaTheme(metaThemeLightUpliftPartial);

export { metaThemeLightUpliftPartial };
